export default __webpack_public_path__ + "b446f33a3ef159f06b936958287b0afb.png";